import React from 'react'
import styles from './button.module.scss'
import PropTypes from 'prop-types'

const Shell = ({ href, children, ...rest }) => {
  return React.createElement(href ? 'a' : 'button', { href, ...rest }, children)
}

Shell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  href: PropTypes.string,
}

const Button = ({ children, outline = false, className = '', ...rest }) => {
  const classes = [styles.button, className]

  if (outline) {
    classes.push(styles.outline)
  }

  return (
    <Shell className={`${classes.join(' ')}`} {...rest}>
      {children}
    </Shell>
  )
}

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  outline: PropTypes.bool,
}

export { Button }
